module.exports = __webpack_public_path__ + "img/tablets.9ac6cad2.svg";